// extracted by mini-css-extract-plugin
module.exports = {"uriRow":"redirect-uri-row__uriRow___KIiZe","uriCell":"redirect-uri-row__uriCell___DnqYQ"};